import { render, staticRenderFns } from "./LocByGroupReport.vue?vue&type=template&id=2670053f&scoped=true&"
import script from "./LocByGroupReport.vue?vue&type=script&lang=js&"
export * from "./LocByGroupReport.vue?vue&type=script&lang=js&"
import style0 from "./LocByGroupReport.vue?vue&type=style&index=0&id=2670053f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670053f",
  null
  
)

export default component.exports